/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { scrollToAnchor } from "../../../../../../theme/commonStyle";
import poaThumbnail from "../../../../../../assets/img/thumbnail/schufa_poa_thumbnail.jpg";

export const wbsColor = "#E61F00";
